import { browser } from '$app/environment';
import { writable } from 'svelte/store';
import { setCookie } from 'utils/cookieStorage';

const currencyDefaultValue = 'usd';
const localStorageItem = 'crypto_currency';

const currencyInitialValue = browser
	? window?.localStorage.getItem(localStorageItem) ?? currencyDefaultValue
	: currencyDefaultValue;

const activeCurrency = writable<{
	currency: string;
	price: number;
}>({
	currency: currencyInitialValue,
	price: 1,
});

activeCurrency.subscribe((value) => {
	if (browser && window.localStorage) {
		window.localStorage.setItem(localStorageItem, value.currency);
		setCookie('crypto_currency', value.currency.toUpperCase());
	}
});
export default activeCurrency;
